'use client';

import { PropsWithChildren } from 'react';
import { useTheme } from '@emotion/react';
import { DEVICE_SCREENS_MAX_STRING } from '../../lib/consts';

export default function ActionsItemFavorite({ children }: PropsWithChildren) {
  const theme = useTheme();
  return (
    <div
      // actions__item actions__item_favorite
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      css={{
        ...theme.mixins.col(4),
        marginBottom: 16,
        '> div': { padding: 0, height: '100%', width: '100%' },
        [DEVICE_SCREENS_MAX_STRING.xl]: {
          ...theme.mixins.col(3),
        },
        [DEVICE_SCREENS_MAX_STRING.md]: {
          ...theme.mixins.col(2),
        },
        [DEVICE_SCREENS_MAX_STRING.sm]: {
          maxWidth: '100%',
        },
      }}
    >
      {children}
    </div>
  );
}
